import { render, staticRenderFns } from "./ClientCoordinates.vue?vue&type=template&id=588dfa0a&scoped=true&"
import script from "./ClientCoordinates.vue?vue&type=script&lang=js&"
export * from "./ClientCoordinates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588dfa0a",
  null
  
)

export default component.exports